<template>
    <div
        class="min-h-full mobile:w-full laptop:w-1/3 flex mobile:flex-row laptop:flex-col mobile:justify-between laptop:justify-start py-4 px-3 rounded-[20px] bg-[#092E87]">
        <div
            class="mobile:flex flex-col-reverse justify-between laptop:block mobile:gap-3 laptop:gap-0 mobile:max-w-[30%] laptop:max-w-full">
            <div>
                <label class="text-sm font-normal mb-1 text-white">Quote ID:</label>
                <h4 class="mobile:text-[22px] laptop:text-3xl font-normal text-white">
                    {{ invoiceDetail?.quote_id ?? '-' }}</h4>
            </div>
            <div>
                <label class="text-sm font-normal mb-1 text-white">Invoice ID:</label>
                <h4 class="mobile:text-[22px] laptop:text-3xl font-normal text-white">{{
                    invoiceDetail?.id ??
                    '-' }}</h4>
            </div>
        </div>
        <div
            class="mobile:flex justify-between flex-col laptop:block mobile:gap-3 laptop:gap-0 mobile:max-w-[70%] laptop:max-w-full">
            <div>
                <label class="text-sm font-normal mb-1 text-white">Invoice Type:</label>
                <h4 class="mobile:text-[22px] laptop:text-3xl font-normal text-white">
                    {{ invoiceDetail?.type ?? '-' }}</h4>
            </div>
            <div>
                <label class="text-sm font-normal mb-1 text-white">Amount Due:</label>
                <h4 class="mobile:text-[22px] laptop:text-[46px] mobile:font-normal laptop:font-bold text-white">${{
                    $helper.formatAmount(invoiceDetail?.amount ?? '0') }}</h4>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['invoiceDetail']
}
</script>